/**
 * Shared "AI thinking" palette — three colors sampled from the icosahedron's
 * MeshNormalMaterial normal-to-RGB mapping. Reused by:
 *   - ChatMessage's ThinkingIndicator dots
 *   - HeaderActivityStrip's flowing gradient
 *   - HeroShape (implicitly, via meshNormalMaterial)
 *
 * Keeping these here so dots, header strip, and 3D shape all glow the same
 * when an LLM query is in flight.
 */

export const AI_PALETTE = {
  cyan:    '#67e8f9', // top-facing normals
  indigo:  '#818cf8', // side-facing normals
  fuchsia: '#e879f9', // down-facing normals
} as const;

export const AI_PALETTE_GLOWS = {
  cyan:    'rgba(103, 232, 249, 0.5)',
  indigo:  'rgba(129, 140, 248, 0.5)',
  fuchsia: 'rgba(232, 121, 249, 0.5)',
} as const;
